// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PrescriberLongResponse {
    static getAttributeTypeMap() {
        return PrescriberLongResponse.attributeTypeMap;
    }
}
PrescriberLongResponse.discriminator = undefined;
PrescriberLongResponse.additionalProperties = false;
PrescriberLongResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": "Array<string>"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "number"
    },
];
//# sourceMappingURL=prescriberLongResponse.js.map